export default __webpack_public_path__ + "static/laptop-3f096eb48767ce9bb14073d6791bd68a.png";